import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import BloggersServices from './bloggersServices';

export const BloggerUploadImage = createAsyncThunk(
  'blogger/uploadimage',
  async (payload, thunkAPI) => {
    try {
      let response = await BloggersServices.BloggerImageUpload(payload);

      return response;
    } catch (error) {
      toast(error.message);
      throw thunkAPI.rejectWithValue(error);
    }
  }
);

export const PostBlogger = createAsyncThunk(
  'blogger/postBlog',
  async (payload, thunkAPI) => {
    try {
      let response = await BloggersServices.postBlogger(payload);

      return response;
    } catch (error) {
      toast(error.message);
      throw thunkAPI.rejectWithValue(error);
    }
  }
);

export const EditBlogger = createAsyncThunk(
  'blogger/editBlog',
  async (payload, thunkAPI) => {
    try {
      let response = await BloggersServices.editABlogger(payload);

      return response;
    } catch (error) {
      toast(error.message);
      throw thunkAPI.rejectWithValue(error);
    }
  }
);

export const DeleteBlogger = createAsyncThunk(
  'blogger/deleteBlog',
  async (payload, thunkAPI) => {
    try {
      let response = await BloggersServices.editABlogger(payload);

      return response;
    } catch (error) {
      toast(error.message);
      throw thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetBlogger = createAsyncThunk(
  'blogger/getBlog',
  async (payload, thunkAPI) => {
    try {
      let response = await BloggersServices.getBlogger(payload);

      return response;
    } catch (error) {
      toast(error.message);
      throw thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetBloggerAdvanced = createAsyncThunk(
  'blogger/getAdvBlog',
  async (payload, thunkAPI) => {
    try {
      let response = await BloggersServices.getBlogger(payload);

      return response;
    } catch (error) {
      toast(error.message);
      throw thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetMyBlogger = createAsyncThunk(
  'blogger/getmyBlog',
  async (payload, thunkAPI) => {
    try {
      let response = await BloggersServices.getMyBlogger(payload);

      return response;
    } catch (error) {
      toast(error.message);
      throw thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetMyBloggerAdvanced = createAsyncThunk(
  'blogger/getmyAdvBlog',
  async (payload, thunkAPI) => {
    try {
      let response = await BloggersServices.getMyBlogger(payload);

      return response;
    } catch (error) {
      toast(error.message);
      throw thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetSingleBlogger = createAsyncThunk(
  'blogger/getSingleBlog',
  async (payload, thunkAPI) => {
    try {
      let response = await BloggersServices.getSingleBlogger(payload);

      return response;
    } catch (error) {
      toast(error.message);
      throw thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetAllBlogger = createAsyncThunk(
  'blogger/getAllBlog',
  async (payload, thunkAPI) => {
    try {
      let response = await BloggersServices.getAllBlogger(payload);

      return response;
    } catch (error) {
      toast(error.message);
      throw thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetAllBloggerAdvanced = createAsyncThunk(
  'blogger/getAllAdvBlog',
  async (payload, thunkAPI) => {
    try {
      let response = await BloggersServices.getAllBlogger(payload);

      return response;
    } catch (error) {
      toast(error.message);
      throw thunkAPI.rejectWithValue(error);
    }
  }
);

export const PostComment = createAsyncThunk(
  'blogger/postComment',
  async (payload, thunkAPI) => {
    try {
      let response = await BloggersServices.createComment(payload);

      return response;
    } catch (error) {
      toast(error.message);
      throw thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetAllBlogCount = createAsyncThunk(
  'blogger/get_all_blog_count',
  async (_, thunkAPI) => {
    try {
      let response = await BloggersServices.getAllBlogCount();

      return response;
    } catch (error) {
      toast(error.message);
      throw thunkAPI.rejectWithValue(error);
    }
  }
);

export const SearchForBlogsByTitle = createAsyncThunk(
  'category/searchForBlogsByTitle',
  async (payload, thunkAPI) => {
    try {
      const delivered = await BloggersServices.SearchForBlogByTitle(payload);

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);
